module.exports = __webpack_public_path__ + "img/btn_google_signin_light_focus_web@2x.9523da15.png";